module.exports = __webpack_public_path__ + "img/Freespin_h3.597f0207.png";